import { Component, OnInit, ViewChild } from '@angular/core';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { TimeOffRequestRules } from '@models/time-off-v3/time-off-request-rules.model';
import { AnalyticService, NotifyService } from '@app/services';
import { TranslatableKey } from '@app/types/translatable.type';
import { PolicyChangeConfirmationDialogComponent } from '@time-off-v3/components';
import { BaseForm } from '@forms/base.form';
import { Location } from '@angular/common';

@Component({
    templateUrl: './request-rules-update.template.html',
    styleUrls: ['./request-rules-update.style.scss'],
})
export class RequestRulesUpdateView extends BaseForm implements OnInit {
    @ViewChild('confirmation', { static: true }) confirmation: PolicyChangeConfirmationDialogComponent;

    isLoading = false;
    timeOffPolicy: TimeOffPolicy;
    timeOffRequestRule: TimeOffRequestRules;
    unitOfTime: TranslatableKey;

    constructor(
        private analyticService: AnalyticService,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private router: Router,
        private location: Location
    ) {
        super();
    }

    ngOnInit(): void {
        this.timeOffPolicy = this.route.snapshot.data.models.get('policy');
        this.timeOffRequestRule = this.timeOffPolicy.timeOffRequestRule;
        this.unitOfTime = this.timeOffPolicy.timeOffType.unitOfTimePluralTranslation as TranslatableKey;
    }

    onCancel(): void {
        this.location.back();
    }

    async onSave(): Promise<void> {
        this.submit();

        if (!this.valid) {
            return;
        }

        this.isLoading = true;

        try {
            if (this.timeOffRequestRule.isDirty()) {
                await this.timeOffRequestRule.save();
            }

            this.analyticService.trackEvent(AnalyticEvents.TimeOffTimeOffPolicyEditTimeOffPolicy);
            this.notify.success('time-off-v3.policyComponents.timeOffRule.savedSuccessfully');

            this.router.navigate(['../'], { relativeTo: this.route });
        } catch (error) {
            this.notify.error(error);
        } finally {
            this.isLoading = false;
        }
    }
}
